// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"CreateBtn--next-sr-only--3rCErCE","wrap":"CreateBtn--wrap--2ewxS8h","btn":"CreateBtn--btn--IHbkAlr"};